import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import BASE_URL from "../../../config/config";

const JobFormWithTable = () => {
  const [formData, setFormData] = useState({
    title: "",
    experience: "",
    urgent: false,
    description: "",
  });
  // for snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // 'success', 'error', 'warning', 'info'

  const handleSnackbarOpen = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  // snckbar end

  const [jobs, setJobs] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 2;

  const totalPages = Math.ceil(jobs.length / jobsPerPage);
  const indexOfLast = currentPage * jobsPerPage;
  const indexOfFirst = indexOfLast - jobsPerPage;
  const currentJobs = jobs.slice(indexOfFirst, indexOfLast);
  // <<<<<<<<<<<<<<<<--------------fetching all the data----------->>>>>>>
  const fetchJobs = async () => {
    try {
      const response = await fetch(`${BASE_URL}/careers/list`);
      const data = await response.json();
      if (response.ok) {
        setJobs(data.data || []);
      } else {
        throw new Error(data.message || "Failed to fetch jobs");
      }
    } catch (error) {
      console.error("Error fetching jobs:", error.message);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);
  // <<<<<<<<<<<<<<<<--------------prevent default data change----------->>>>>>>
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, description: value }));
  };
  // <<<<<<<<<<<<<<<<--------------for the saving the data & updation of the data ----------->>>>>>>
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      const isEditing = editingIndex !== null;
      const method = isEditing ? "PUT" : "POST";
      const url = isEditing
        ? `${BASE_URL}/careers/${formData.id}`
        : `${BASE_URL}/careers/create`;

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      // if (!response.ok) throw new Error(result.message);

      // await fetchJobs();
      // setFormData({
      //   title: "",
      //   experience: "",
      //   urgent: false,
      //   description: "",
      // });
      // setEditingIndex(null);
      if (!response.ok) throw new Error(result.message);

      await fetchJobs();
      setFormData({
        title: "",
        experience: "",
        urgent: false,
        description: "",
      });
      setEditingIndex(null);
      handleSnackbarOpen(
        isEditing ? "Job updated successfully!" : "Job created successfully!"
      );
    } catch (error) {
      console.error("Error submitting job:", error.message);
      alert("Something went wrong!");
    }
  };

  const handleEdit = (index) => {
    const jobToEdit = jobs[indexOfFirst + index];
    setFormData(jobToEdit);
    setEditingIndex(indexOfFirst + index);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${BASE_URL}/careers/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);

      await fetchJobs();
      handleSnackbarOpen("Job deleted successfully!");
    } catch (error) {
      console.error("Error deleting job:", error.message);
      alert("Delete failed: " + error.message);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "bullet",
    "indent",
    "align",
  ];

  return (
    <div className="p- w-full mx-auto space-y-10">
      {/* Job Form */}
      <div className="bg-white p-6 rounded shadow space-y-4 border">
        <h2 className="text-xl font-semibold">
          {editingIndex !== null ? "Edit Job" : "Add New Job"}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="title" className="block text-sm font-medium mb-1">
              Job Title
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Job Title"
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <div>
            <label
              htmlFor="experience"
              className="block text-sm font-medium mb-1"
            >
              Experience
            </label>
            <input
              type="text"
              id="experience"
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              placeholder="e.g., 0-2 Years"
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <div>
            <label
              htmlFor="description"
              className="block text-sm font-medium mb-1"
            >
              Job Description
            </label>
            <ReactQuill
              id="description"
              value={formData.description}
              onChange={handleQuillChange}
              className="bg-white"
              theme="snow"
              modules={quillModules}
              formats={quillFormats}
            />
          </div>

          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="urgent"
              name="urgent"
              checked={formData.urgent}
              onChange={handleChange}
              className="w-4 h-4"
            />
            <label htmlFor="urgent" className="text-sm">
              Mark as Urgent
            </label>
          </div>

          <button
            type="submit"
            className="bg-gray-700 w-full text-white px-4 py-2 rounded hover:bg-gray-900"
          >
            {editingIndex !== null ? "Update Job" : "Save Job"}
          </button>
        </form>
      </div>

      {/* Job Table */}
      <div className="bg-white p-6 rounded shadow border">
        <h2 className="text-xl font-semibold mb-4">Job Listings</h2>

        {jobs.length === 0 ? (
          <p>No jobs found.</p>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full table-auto border text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border p-2">#</th>
                    <th className="border p-2">Title</th>
                    <th className="border p-2">Experience</th>
                    <th className="border p-2">Urgent</th>
                    <th className="border p-2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentJobs.map((job, i) => (
                    <tr key={job._id}>
                      <td className="border p-2 text-center">
                        {indexOfFirst + i + 1}
                      </td>
                      <td className="border p-2">{job.title}</td>
                      <td className="border p-2">{job.experience}</td>
                      <td className="border p-2 text-center">
                        {job.urgent ? (
                          <span className="text-white bg-red-500 px-2 py-1 rounded text-xs">
                            Urgent
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="border p-2 space-x-2 text-center">
                        <button
                          onClick={() => handleEdit(i)}
                          className="px-2 py-1 bg-yellow-500 text-white text-xs rounded"
                        >
                          <FontAwesomeIcon icon={faPenSquare} />
                        </button>
                        <button
                          onClick={() => handleDelete(job.id)}
                          className="px-2 py-1 bg-red-600 text-white text-xs rounded"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="flex justify-center items-center mt-6 space-x-4">
              <button
                onClick={prevPage}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-main text-white rounded-full shadow-sm hover:bg-main1 disabled:bg-blue-300 disabled:cursor-not-allowed transition duration-200"
              >
                Previous
              </button>

              <span className="text-sm font-medium text-gray-700">
                Page{" "}
                <span className="text-blue-600 font-semibold">
                  {currentPage}
                </span>{" "}
                of {totalPages}
              </span>

              <button
                onClick={nextPage}
                disabled={currentPage === totalPages}
                className="px-4 py-2 bg-main text-white rounded-full shadow-sm hover:bg-main1 disabled:bg-blue-300 disabled:cursor-not-allowed transition duration-200"
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default JobFormWithTable;
